import { Version } from '@tools/version/version';

export const APP_VERSION = new Version('13.1.0').full;
